import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { ValidationErrorService } from 'src/app/core/validation/validation-error.service';
import { PASSTHROUGH_STATUS_CODES, SKIP_ERROR_HANDLING } from 'src/app/shared/context/error-handling.context';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private messageService: MessageService,
    private validationErrorService: ValidationErrorService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Fehler überspringen
        if (req.context.get(SKIP_ERROR_HANDLING)) {
          return throwError(() => error);
        }

        // Bestimmte Status-Codes still durchreichen (kein Toast, catchError im Store übernimmt)
        if (req.context.get(PASSTHROUGH_STATUS_CODES).includes(error.status)) {
          return throwError(() => error);
        }

        if (error.status === 0) {
          // Netzwerkfehler (z.B. keine Verbindung oder CORS-Problem)
          this.messageService.add({severity: 'error', summary: 'Netzwerkfehler', detail: 'Keine Verbindung zum Server.'});
        } else {
          const errorMessage = error?.error?.detail ;
          if(errorMessage) console.log('Error message:', error.error);
          switch (error.status) {
            case 400:
              if (error.error?.errors) {
                // Validierungsfehler-Objekt von der API
                this.messageService.add({severity: 'warn', summary: 'Einige Eingaben sind fehlerhaft', detail: 'Bitte prüfen Sie die mit Fehlern gekennzeichneten Eingabefelder.'});
                this.validationErrorService.set(error.error.errors);
              } else {
                if(error.error && typeof error.error === 'string') {
                  this.messageService.add({severity: 'error', summary: 'Fehler', detail: error.error});
                } else {
                  // Allgemeiner Bad Request ohne Validierungsobjekt
                  const detail = error.error?.title || 'Ungültige Anfrage.';
                  this.messageService.add({severity: 'error', summary: 'Fehler 400', detail});
                }
                
              }
              break;
              case 401:
                this.messageService.add({severity: 'error', summary: 'Nicht autorisiert', detail: 'Ihre Sitzung ist abgelaufen oder Sie sind nicht angemeldet. Bitte melden Sie sich erneut an.'});
                break;
            case 403:
              // Nicht autorisiert / Forbidden
              this.messageService.add({severity: 'error', summary: 'Zugriff verweigert', detail: 'Ihre Rolle erlaubt diese Aktion nicht.'});
              // Optional: Zentralen Logout/Redirect anstoßen
              //this.authService.logout?.();
              break;
            case 404:
              this.messageService.add({severity: 'error', summary: 'Nicht gefunden', detail: error.error || error.error?.title || 'Die angeforderte Ressource wurde nicht gefunden.'});
              break;
            case 409:
                this.messageService.add({severity: 'error', summary: 'Nicht gefunden', detail: error.error?.message ||  error.error?.title ||error.error  || 'Die angeforderte Ressource wurde nicht gefunden.'});
                break;
            case 422:
              // Unprocessable Entity – kann ähnlich wie Validierungsfehler behandelt werden
              this.messageService.add({severity: 'warn', summary: 'Einige Eingaben sind fehlerhaft', detail: error.error?.title || 'Bitte prüfen Sie die mit Fehlern gekennzeichneten Eingabefelder.'});
              if (error.error?.errors) {
                this.validationErrorService.set(error.error.errors);
              }
              break;
            case 500:
            default:
              // Allgemeiner Serverfehler oder unbekannter Fehlerstatus
              const msg = errorMessage || error.error || error.error?.title || 'Es ist ein unerwarteter Fehler aufgetreten.';
              this.messageService.add({severity: 'error', summary: 'Serverfehler', detail: msg});
              break;
          }
        }
        // Fehler weiterwerfen, damit Aufrufer ihn ggf. sehen (oder von GlobalErrorHandler erfasst wird)
        return throwError(() => error);
      })
    );
  }
}